import { AppState, Owner } from '../../types';

export const getProfileUrls = (state: AppState) => state.profileUrls;

export const getProfileUrlByUser = (state: AppState, user: Owner | undefined) =>
  user?.siteMemberId ? getProfileUrls(state)?.[user?.siteMemberId] : undefined;
